/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */
import {
  GET_PRINTERS_REQUEST,
  GET_PRINTERS_SUCCESS,
  GET_PRINTERS_FAILURE,
} from "./printerOnboardingTypes";

const initialState = {
  loading: false,
  printers: {},
  error: "",
};

const printersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRINTERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PRINTERS_SUCCESS:
      return {
        loading: false,
        printers: action.payload,
        error: "",
      };
    case GET_PRINTERS_FAILURE:
      return {
        loading: false,
        printers: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export { printersReducer };
